import { combineReducers } from '@reduxjs/toolkit';

import { global, user } from '@/modules';
import editBannerForm from '@/modules/editBannerForm';

const rootReducer = combineReducers({
  global: global.reducer,
  user: user.reducer,
  editForm: editBannerForm.reducer,
});

export default rootReducer;
